// =============================================================================
// SHANIZ GAMING ADMIN - THEME TOGGLE BUTTON
// =============================================================================

import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { DarkMode, LightMode } from '@mui/icons-material';
import { useColorMode } from '../context/ColorModeContext';

export const ThemeToggle: React.FC = () => {
  const { mode, toggleMode } = useColorMode();
  return (
    <Tooltip title={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
      <IconButton
        onClick={toggleMode}
        size="small"
        aria-label="toggle theme"
        sx={{ color: 'text.secondary' }}
      >
        {mode === 'dark' ? <LightMode fontSize="small" /> : <DarkMode fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
};
